import { LinearProgress } from "@mui/material";
import React, { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useRecoilState } from "recoil";
import { useGetProfile } from "src/api/profile";
import { ConstLocalStorage } from "src/constants/_localStorage";
import { authState } from "src/store/auth";
import { setLocalStoredData } from "src/utils/_localStorage";

export const PrivateRoutes: React.FC = () => {
  const { data, status, isLoading } = useGetProfile();
  const [auth, setAuth] = useRecoilState(authState);

  useEffect(() => {
    if (status === "success") {
      // update permissions and user data with each rerender
      setAuth({ ...auth, permissions: data.data.roles, user: data.data.user });
      setLocalStoredData(ConstLocalStorage.permissions, data.data.roles);
    }
  }, [status]);

  return auth.token ? (
    isLoading ? (
      <LinearProgress />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to={"/login"} />
  );
};
